var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPersonalisation = function SvgPersonalisation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    zoomAndPan: "magnify",
    viewBox: "0 0 60 60",
    height: "1em",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "87697b5d71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.058594 1.28125 L 26.558594 1.28125 L 26.558594 26.78125 L 1.058594 26.78125 Z M 1.058594 1.28125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e4048918f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 7 L 37 7 L 37 56 L 1 56 Z M 1 7 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3b27edeca5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -5.425781 16.414062 L 19.367188 7.792969 L 36.863281 58.085938 L 12.070312 66.710938 Z M -5.425781 16.414062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b508a5b5fd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -5.425781 16.414062 L 19.367188 7.792969 L 36.863281 58.085938 L 12.070312 66.710938 Z M -5.425781 16.414062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb8b1cd34c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -5.425781 16.414062 L 46.996094 -1.816406 L 64.488281 48.476562 L 12.070312 66.710938 Z M -5.425781 16.414062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cc6b8e22b7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4 7 L 54 7 L 54 33 L 4 33 Z M 4 7 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6b4dfdb2ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 57.28125 8.363281 L 54 32.894531 L 1.222656 25.84375 L 4.5 1.3125 Z M 57.28125 8.363281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7975e9b383"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 57.28125 8.363281 L 54 32.894531 L 1.222656 25.84375 L 4.5 1.3125 Z M 57.28125 8.363281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b492543d21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 57.28125 8.363281 L 49.929688 63.375 L -2.851562 56.324219 L 4.5 1.3125 Z M 57.28125 8.363281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b933aa74d3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25 11 L 55 11 L 55 55 L 25 55 Z M 25 11 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f2b066012e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 42.65625 66.230469 L 25.824219 57.96875 L 48.628906 11.515625 L 65.460938 19.777344 Z M 42.65625 66.230469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1341e4bb7a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 42.65625 66.230469 L -7.164062 41.773438 L 16.300781 -6.027344 L 66.121094 18.429688 Z M 42.65625 66.230469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "899857e6bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 42.65625 66.230469 L -7.164062 41.773438 L 16.300781 -6.027344 L 66.121094 18.429688 Z M 42.65625 66.230469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "139144c5e5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21 18.5 L 37 18.5 L 37 34 L 21 34 Z M 21 18.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0281f36001"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16.40625 35 L 41.90625 35 L 41.90625 56 L 16.40625 56 Z M 16.40625 35 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#87697b5d71)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eef1ed",
    d: "M 26.875 14.191406 C 26.875 15.039062 26.792969 15.878906 26.628906 16.710938 C 26.464844 17.539062 26.21875 18.347656 25.894531 19.128906 C 25.570312 19.914062 25.171875 20.65625 24.699219 21.363281 C 24.230469 22.066406 23.695312 22.71875 23.09375 23.316406 C 22.496094 23.917969 21.84375 24.453125 21.140625 24.921875 C 20.433594 25.394531 19.691406 25.792969 18.90625 26.117188 C 18.125 26.441406 17.316406 26.6875 16.488281 26.851562 C 15.65625 27.015625 14.816406 27.097656 13.96875 27.097656 C 13.121094 27.097656 12.28125 27.015625 11.449219 26.851562 C 10.617188 26.6875 9.8125 26.441406 9.027344 26.117188 C 8.246094 25.792969 7.5 25.394531 6.796875 24.921875 C 6.09375 24.453125 5.441406 23.917969 4.839844 23.316406 C 4.242188 22.71875 3.707031 22.066406 3.234375 21.363281 C 2.765625 20.65625 2.367188 19.914062 2.042969 19.128906 C 1.71875 18.347656 1.472656 17.539062 1.308594 16.710938 C 1.140625 15.878906 1.058594 15.039062 1.058594 14.191406 C 1.058594 13.34375 1.140625 12.503906 1.308594 11.671875 C 1.472656 10.839844 1.71875 10.035156 2.042969 9.25 C 2.367188 8.46875 2.765625 7.722656 3.234375 7.019531 C 3.707031 6.316406 4.242188 5.664062 4.839844 5.0625 C 5.441406 4.464844 6.09375 3.929688 6.796875 3.457031 C 7.5 2.988281 8.246094 2.589844 9.027344 2.265625 C 9.8125 1.941406 10.617188 1.695312 11.449219 1.53125 C 12.28125 1.367188 13.121094 1.28125 13.96875 1.28125 C 14.816406 1.28125 15.65625 1.367188 16.488281 1.53125 C 17.316406 1.695312 18.125 1.941406 18.90625 2.265625 C 19.691406 2.589844 20.433594 2.988281 21.140625 3.457031 C 21.84375 3.929688 22.496094 4.464844 23.09375 5.0625 C 23.695312 5.664062 24.230469 6.316406 24.699219 7.019531 C 25.171875 7.722656 25.570312 8.46875 25.894531 9.25 C 26.21875 10.035156 26.464844 10.839844 26.628906 11.671875 C 26.792969 12.503906 26.875 13.34375 26.875 14.191406 Z M 26.875 14.191406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e4048918f0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3b27edeca5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b508a5b5fd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb8b1cd34c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 5.4375 32.300781 L 7.1875 32.464844 L 4.871094 26.488281 L 1.488281 31.925781 L 3.515625 32.117188 C 4.03125 43.347656 12.15625 53.183594 23.664062 55.394531 C 37.117188 57.976562 50.121094 49.136719 52.683594 35.667969 C 55.246094 22.199219 46.402344 9.164062 32.949219 6.582031 C 28.671875 5.757812 24.253906 6.078125 20.140625 7.511719 L 20.769531 9.316406 C 24.566406 7.996094 28.644531 7.699219 32.59375 8.457031 C 45.011719 10.84375 53.171875 22.875 50.808594 35.308594 C 48.441406 47.742188 36.4375 55.898438 24.019531 53.515625 C 13.492188 51.496094 6.027344 42.554688 5.4375 32.300781 Z M 5.4375 32.300781 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc6b8e22b7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6b4dfdb2ae)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7975e9b383)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b492543d21)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 38.203125 10.902344 L 37.265625 12.390625 L 43.648438 13.015625 L 40.316406 7.542969 L 39.230469 9.269531 C 28.976562 4.667969 16.53125 7.488281 9.375 16.761719 C 1.003906 27.609375 3.035156 43.199219 13.902344 51.558594 C 24.773438 59.917969 40.390625 57.898438 48.761719 47.054688 C 51.421875 43.605469 53.128906 39.515625 53.707031 35.199219 L 51.808594 34.945312 C 51.277344 38.933594 49.703125 42.707031 47.246094 45.890625 C 39.519531 55.898438 25.101562 57.761719 15.070312 50.046875 C 5.035156 42.332031 3.164062 27.9375 10.890625 17.929688 C 17.441406 9.4375 28.785156 6.808594 38.203125 10.902344 Z M 38.203125 10.902344 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b933aa74d3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f2b066012e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1341e4bb7a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#899857e6bb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 46.316406 47.339844 L 45.203125 45.976562 L 42.582031 51.828125 L 48.828125 50.410156 L 47.535156 48.832031 C 55.160156 40.570312 56.441406 27.878906 49.921875 18.140625 C 42.300781 6.757812 26.875 3.726562 15.492188 11.375 C 4.113281 19.023438 1.058594 34.472656 8.679688 45.855469 C 11.105469 49.476562 14.441406 52.394531 18.347656 54.3125 L 19.191406 52.597656 C 15.582031 50.824219 12.503906 48.132812 10.269531 44.789062 C 3.234375 34.285156 6.050781 20.023438 16.554688 12.960938 C 27.058594 5.902344 41.300781 8.699219 48.335938 19.207031 C 54.300781 28.117188 53.191406 39.710938 46.316406 47.339844 Z M 46.316406 47.339844 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#139144c5e5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 29.171875 33.851562 L 29.164062 33.851562 C 28.144531 33.851562 27.164062 33.65625 26.222656 33.265625 C 25.28125 32.875 24.453125 32.320312 23.738281 31.597656 C 23.019531 30.875 22.460938 30.046875 22.070312 29.109375 C 21.679688 28.167969 21.484375 27.191406 21.480469 26.175781 C 21.472656 24.109375 22.367188 22.078125 23.9375 20.609375 C 25.414062 19.226562 27.335938 18.496094 29.210938 18.613281 C 31.058594 18.515625 32.957031 19.25 34.421875 20.628906 C 35.984375 22.101562 36.871094 24.132812 36.863281 26.195312 C 36.859375 27.210938 36.664062 28.1875 36.269531 29.125 C 35.878906 30.0625 35.320312 30.890625 34.597656 31.609375 C 33.882812 32.328125 33.050781 32.882812 32.113281 33.273438 C 31.171875 33.660156 30.191406 33.855469 29.171875 33.851562 Z M 29.171875 33.851562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0281f36001)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 29.132812 55.996094 C 25.667969 55.992188 22.382812 55.222656 19.28125 53.691406 C 17.296875 52.710938 16.40625 51.917969 16.480469 51.199219 L 17.429688 41.835938 C 17.433594 40.355469 17.984375 38.953125 19.027344 37.777344 C 20.035156 36.640625 21.46875 35.792969 23.0625 35.390625 C 23.769531 35.214844 24.492188 35.128906 25.222656 35.132812 L 33.390625 35.132812 C 35.371094 35.253906 37.210938 36.003906 38.570312 37.246094 C 39.925781 38.488281 40.683594 40.121094 40.6875 41.832031 L 41.816406 51.121094 C 41.902344 51.84375 41.035156 52.640625 39.085938 53.628906 C 35.976562 55.191406 32.675781 55.984375 29.191406 55.996094 Z M 29.132812 55.996094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
};
export default SvgPersonalisation;